import request from '@/utils/request'

export default {
  /**
   * 员工所有赠送卡
   */
  getGivingCards() {
    return request.get('/giving-cards/staff-all-cards')
  }
}
